import { faker } from '@faker-js/faker';
import { generateFromEnum, generateInitialPaginationApi } from '@ingenico/api-sdk-core/mocks';
import type {
  LogicalDeviceListResponseApi,
  LogicalDeviceResourceReadApi,
  ParentEntityApi,
} from '@ingenico/api-sdk-provisioning-public';
import {
  enumEntityStatus,
  enumLogicalDeviceType,
  provisioningEntityTypeEnum,
} from '@ingenico/api-sdk-provisioning-public';
import { HttpResponse } from 'msw';

// Route: POST logical-devices/search
function generateParentEntityApi(): ParentEntityApi {
  return {
    id: faker.string.uuid(),
    type: generateFromEnum(provisioningEntityTypeEnum),
  };
}

function generateLogicalDeviceResourceReadApi(): LogicalDeviceResourceReadApi {
  return {
    id: faker.string.uuid(),
    isEnabled: faker.datatype.boolean(),
    logicalDeviceType: generateFromEnum(enumLogicalDeviceType),
    name: faker.company.name(),
    parent: generateParentEntityApi(),
    reference: faker.string.alphanumeric(8),
    status: generateFromEnum(enumEntityStatus),
    statusNote: faker.lorem.sentence(),
    tags: [],
  };
}

export function searchLogicalDevicesV1ResponseMock(): LogicalDeviceListResponseApi {
  const count = faker.number.int({ min: 3, max: 25 });

  return {
    pagination: generateInitialPaginationApi(count),
    data: faker.helpers.multiple(generateLogicalDeviceResourceReadApi, { count }),
  };
}

export function searchLogicalDevicesV1Handler() {
  return HttpResponse.json<LogicalDeviceListResponseApi>(searchLogicalDevicesV1ResponseMock());
}
